export const STATUS = [
    {
        value: "Active",
        label: 'Active'
    },
    {
        value: "Inactive",
        label: 'Inactive'
    }
];

export const STATUS_DROPDOWN = [
    {
        value: 1,
        label: 'Active'
    },
    {
        value: 0,
        label: 'Inactive'
    }
];

// export const HOTEL_TYPE = ['Budget', 'Boutique', 'Resort', 'Luxury'];
export const HOTEL_TYPE = [
    'Guest House',
    'Deluxe Hotels',
    'Budget Hotels',
    'Luxury Hotels',
    'Club Hotels',
    'Bed & Breakfast',
    'Bed and Breakfast',
    'Rental Homes',
    'Boutique Hotels',
    'Farm House',
    'Unique Hotels',
    'Famous Place',
    'BnB',
    'B&B',
    'Eco Green Hotels',
    'Ecotel Hotels',
    'Eco Hotels',
    'Apart Hotels',
    'Apartment Hotels',
    'Service Apartment',
    'Vilas',
    'Villas',
    'Cheap Hotels',
    'Eco Friendly',
    'Environment Friendly Hotels',
    'Palace',
    'Tent House',
    'Tent Hotels',
    'Luxury Palace',
    'Heritage Style Hotels',
    'Luxury Tents',
    'Beach Homes',
    'Beach House',
    'HIP Hotels',
    'Vacation Rentals',
    'Hotels',
    'Resorts',
    'Heritage Hotels',
    'Heritage Palace',
    'Motel',
    'Rotel',
    'Botel',
    'Off Road Stay'
];

export const SUCCESS = 'success';
export const DELETE_MSG = 'Successfully Deleted';
export const CREATE_MSG = 'Successfully Created';
export const UPDATE_MSG = 'Successfully Updated';